import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

import { useTranslate } from "localization";
import { DatePicker } from "ui/forms";

import { formattedDate, toGMTDate } from "utilities/general";

import { QUERY_PARAM as PAGINATION_QUERY_PARAM } from "../Pagination";
import { useFilterUpdate } from "./slice";

interface Props {
  v2?: boolean;
}
const DateRange: React.FC<Props> = ({ v2 }) => {
  const { translate } = useTranslate();
  const [query, setQuery] = useSearchParams();
  const updateFilters = useFilterUpdate();

  const dateFrom = query.get("date_from");
  const dateTo = query.get("date_to");

  useEffect(() => {
    dateFrom && updateFilters("date_from", dateFrom);
    dateTo && updateFilters("date_to", dateTo);
    return () => {
      updateFilters("date_from", null);
      updateFilters("date_to", null);
    };
  }, [dateFrom, dateTo, updateFilters]);

  const onChange = (dates: [Date | null, Date | null]) => {
    const start = formattedDate(dates[0]);
    const end = formattedDate(dates[1]);
    updateFilters("date_from", start);
    updateFilters("date_to", end);
    query.delete("date_from");
    query.delete("date_to");
    start && query.set("date_from", start);
    end && query.set("date_to", end);
    // A change in filter means we should reset pagination
    query.delete(PAGINATION_QUERY_PARAM);
    setQuery(query, { replace: true });
  };

  return (
    <DatePicker
      v2={v2}
      startDate={toGMTDate(dateFrom)}
      endDate={toGMTDate(dateTo)}
      onChange={onChange}
      translate={translate}
    />
  );
};

export default DateRange;
